<section class="refund-successfully-container">    
    <img src="./../../../../../../../../assets/images/help_desk/check_animation.gif" alt="check_animation">
    <div class="primary-text">Your Refund request has send Successfully</div>
    <div class="second-text">Note: Your amount will be credited to your account within 7 bank working days.</div>
    <div class="action-btn">
        <button (click)="closePopup()">Ok</button>
    </div>
</section>